import { BasicStatusesTypes, FileType } from 'interfaces';
import { User } from './user.model';

export enum RECOGNITION_MODEL {
  BY_COUNT = 'By Task Count',
  BY_TASK = 'By Specific Task',
}

export type RecognitionModel = keyof typeof RECOGNITION_MODEL;

export interface ReadOnlyFields {
  readonly id: string;
  readonly author: User | null;
  readonly createdAt: string;
  readonly updatedAt: string;
}

export interface DraftRecognition {
  title: string;
  description: string;
  status: BasicStatusesTypes;
  completedTasks: string;
  reward: string;
  stickerPackLink: string;
  feedbackFormLink: string;
  attachments: FileType[];
  type: RecognitionModel;
  taskIds: string[];
}

export type Recognition = DraftRecognition & ReadOnlyFields;
